import * as types from './types';

const INITIAL_STATE = {
  itemListData: [],
  loading: false,
  itemListingError: null,
  printLoading: false,
  printError: null,
  printData: '',
  emptyPrintResponse: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.ITEM_LIST_DATA:
      return { ...state, itemListData: action.payload };

    case types.ITEM_DATA_LOADING:
      return { ...state, loading: action.payload };

    case types.ITEM_DATA_LIST_ERROR:
      return { ...state, itemListingError: action.payload };

    case types.PRINT_BARCODE_LOADING:
      return { ...state, printLoading: action.payload };

    case types.PRINT_BARCODE_ERROR:
      return { ...state, printError: action.payload };

    case types.PRINT_BARCODE_DATA:
      return { ...state, printData: action.payload };

    case types.CLEAR_PRINT_ERROR:
      return {
        ...state,
        printError: null,
        printData: null,
        emptyPrintResponse: null,
        itemListingError: null,
      };

    case types.RESET_PRINT_RESPONSE:
      return { ...state, emptyPrintResponse: null };

    case types.SET_PRINT_RESPONSE_EMPTY:
      return { ...state, emptyPrintResponse: '' };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/pages/utilities/state/printBarcodes/reducer.js